// extracted by mini-css-extract-plugin
module.exports = {"base":"PressContactList-module-base"};